import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from '../utils/posAxios';
import { MdDone, MdClear } from 'react-icons/md';
import StorageService from '../services/StorageService';
import Cleave from 'cleave.js/react';

class CrmCustomerForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isDetail: false,
      isAddress: false,
      isCustomData: false,
      categoryList: [],
      customer_id: '',
      company: '',
      addressList: [],
      data: [],
      name: '',
      email: '',
      contact: '',
      contact_person: '',
      tag: '',
      billing_address: '',
      billing_unit: '',
      billing_postal_code: '',
      billing_country: '',
      remarks: '',
      dob: '',
      category: '',
      membership_id: '',
      dnd: '',
    };
  }

  componentDidMount() {
    this.getCategoryList();
    if (this.props.data.isEdit) {
      let data = this.props.data;
      this.setState({
        isEdit: data.isEdit,
        customer_id: data.customer_id,
        company: data.company,
        category: data.category,
        membership_id: data.membership_id,
        name: data.name,
        email: data.email,
        contact: data.contact,
        contact_person: data.contact_person,
        tag: data.tag,
        billing_address: data.billing_address,
        billing_unit: data.billing_unit,
        billing_postal_code: data.billing_postal_code,
        billing_country: data.billing_country,
        dob: data.dob,
        remarks: data.remarks,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onDateChange = event => {
    this.setState({ dob: event.target.rawValue });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isEdit) {
      this.editCustomer(user, comp, url);
    } else {
      this.addCustomer(user, comp, url);
    }
  };

  getCategoryList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/category', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            categoryList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  addCustomer(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      category: this.state.category,
      membership_id: this.state.membership_id,
      name: this.state.name,
      company: this.state.company,
      contact: this.state.contact,
      contact_person: this.state.contact_person,
      tag: this.state.tag,
      email: this.state.email,
      billing_address: this.state.billing_address,
      billing_unit: this.state.billing_unit,
      billing_country: this.state.billing_country,
      billing_postal_code: this.state.billing_postal_code,
      remarks: this.state.remarks,
      dob: this.state.dob,
      created_by: user.email,
    };
    axios
      .post(url + ':3004/v1/customer/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Customer added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editCustomer(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      company_id: comp.CompanyID,
      category: this.state.category,
      membership_id: this.state.membership_id,
      company: this.state.company,
      name: this.state.name,
      contact: this.state.contact,
      contact_person: this.state.contact_person,
      tag: this.state.tag,
      email: this.state.email,
      billing_address: this.state.billing_address,
      billing_unit: this.state.billing_unit,
      billing_country: this.state.billing_country,
      billing_postal_code: this.state.billing_postal_code,
      remarks: this.state.remarks,
      dob: this.state.dob,
      update_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Customer updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    const detail = (
      <Row>
        <Col md={12}>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Category</Label>
                <Input
                  type="select"
                  name="category"
                  value={this.state.category}
                  onChange={this.changeHandler}
                >
                  <option></option>
                  {this.state.categoryList.map(item => {
                    return (
                      <option key={item.id} value={item.name}>
                        {item.name}
                      </option>
                    );
                  })}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Membership ID</Label>
                <Input
                  type="text"
                  name="membership_id"
                  value={this.state.membership_id}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Company</Label>
                <Input
                  type="text"
                  name="company"
                  value={this.state.company}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Contact</Label>
                <Input
                  type="text"
                  name="contact"
                  value={this.state.contact}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Contact Person</Label>
                <Input
                  type="text"
                  name="contact_person"
                  value={this.state.contact_person}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Tag</Label>
                <Input
                  type="text"
                  name="tag"
                  value={this.state.tag}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Billing Address</Label>
                <Input
                  type="text"
                  name="billing_address"
                  value={this.state.billing_address}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Billing Unit</Label>
                <Input
                  type="text"
                  name="billing_unit"
                  value={this.state.billing_unit}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Billing Country</Label>
                <Input
                  type="select"
                  name="billing_country"
                  value={this.state.billing_country}
                  onChange={this.changeHandler}
                >
                  <option></option>
                  <option value="Singapore">Singapore</option>
                  <option value="Others">Others</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Billing Postal Code</Label>
                <Input
                  type="text"
                  maxLength="6"
                  name="billing_postal_code"
                  value={this.state.billing_postal_code}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Remarks</Label>
                <Input
                  type="text"
                  name="remarks"
                  value={this.state.remarks}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Date of Birth</Label>
                <Cleave
                  className="form-control"
                  placeholder="eg. 31/01"
                  options={{ date: true, datePattern: ['d', 'm'] }}
                  onChange={this.onDateChange}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    );

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Customer Detail
        </ModalHeader>
        <ModalBody>{detail}</ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default CrmCustomerForm;
